module.exports = __webpack_public_path__ + "static/media/Victor-img.07dbc16f.jpeg";